import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { Router } from '@angular/router';
import {Checktoken} from "../models/checktoken.model";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, private router: Router) {}

  getBaseUrl(): string {
    const currentUrl = window.location.href;
    return currentUrl.includes('staging') || currentUrl.includes('localhost')
      ? 'https://staging.cms.kasha.co/api'
      : 'https://cms.kasha.co/api';
  }

  verifyToken(token: string, orgId: string) : Observable<Checktoken>  {
    const url = `${this.getBaseUrl()}/enterprise/check-token`;
    return this.http.get<Checktoken>(`${url}?token=${token}&enterprise_org_id=${orgId}`);
  }

  isLoggedIn():boolean{
    if(localStorage.getItem('token_expires_at') && localStorage.getItem('token')){
      const now = new Date();
      const expiresAt = new Date(localStorage.getItem('token_expires_at') as string);

      return now < expiresAt;

    }else{
      return false;
    }
  }

  logout():void{
    localStorage.removeItem('token_expires_at');
    localStorage.removeItem('token');
    localStorage.removeItem('orgId');
    localStorage.removeItem('email');
    const hostname = window.location.hostname;
    let url = environment.loginRedirectUrls.hivPDSID;
    if (hostname.includes("za")) {
      url = environment.loginRedirectUrls.za_hivPDSID;
    } else if (hostname.includes("pds-delivery-form.kasha.rw")) {
      url = environment.loginRedirectUrls.rw_pdsID;
    } else if (hostname.includes("sanofi")) {
      url = environment.loginRedirectUrls.rw_ncdSanofiID;
    }
    window.location.href = url;
  }

  setToken(token: string){
    localStorage.setItem('token', token);
  }

  getToken():string|null{
    return localStorage.getItem('token');
  }

  getOrgID():string|null{
    return localStorage.getItem('orgId');
  }

}